import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VerticalAlignment } from '@freelancer/ui/grid';
import { IconColor, IconSize } from '@freelancer/ui/icon';

export enum ViewHeaderBackground {
  DARK = 'dark',
  LIGHT = 'light',
  TRANSPARENT = 'transparent',
}

@Component({
  selector: 'fl-view-header',
  template: `
    <fl-bit class="ViewHeaderContent" [attr.data-background]="background">
      <fl-grid [vAlign]="VerticalAlignment.VERTICAL_CENTER">
        <fl-col [col]="1" [flShowMobile]="true">
          <fl-button (click)="handleBack()">
            <fl-icon
              [size]="IconSize.SMALL"
              [name]="'ui-chevron-left'"
              [color]="background === 'dark' ? IconColor.LIGHT : IconColor.DARK"
            ></fl-icon>
          </fl-button>
        </fl-col>

        <fl-col [col]="showMenu ? 10 : 11" [colTablet]="showMenu ? 11 : 12">
          <ng-content></ng-content>
        </fl-col>
        <fl-col *ngIf="showMenu" class="MenuColumn" [col]="1">
          <fl-button (click)="menuClick.emit()">
            <fl-icon
              [name]="'ui-show-more'"
              [size]="IconSize.SMALL"
              [color]="IconColor.DARK"
            ></fl-icon>
          </fl-button>
        </fl-col>
      </fl-grid>
    </fl-bit>
  `,
  styleUrls: ['./view-header.component.scss'],
})
export class ViewHeaderComponent {
  IconSize = IconSize;
  IconColor = IconColor;
  VerticalAlignment = VerticalAlignment;

  @Input() background = ViewHeaderBackground.LIGHT;

  @Input() showMenu = false;
  @Output() menuClick = new EventEmitter();

  constructor(private location: Location) {}

  handleBack() {
    // TODO: handle route changes under one heading (eg. pvp tabs)
    this.location.back();
  }
}
